import { Component, AfterViewInit, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { PriceList } from '../../app/models/Pricelist';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig, ModalDirective } from 'ngx-bootstrap';
import { Config } from '../../providers/config';
import { ConfigService } from '../../providers/config/config.service';
import { NgForm } from '@angular/forms';
import { Zone } from '../../app/models/Zone';
import { TranslateService } from '@ngx-translate/core';
import { AlertsHolder } from '../../app/models/AlertsHolder';

@Component({
  selector: 'page-price-list',
  templateUrl: 'price-list.html',
})
export class PriceListPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('priceListModal')
  private priceListModal: ModalDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('priceListForm')
  private priceListForm: NgForm;

  private pageName: string = 'page-price-list';

  private priceLists: PriceList[] = [];
  private zones: Zone[] = [];
  private currentPriceList = new PriceList();
  public bsConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
  private currentConfiguration: Config;
  private startDate = new Date();
  private endDate: Date;
  private addModalAlertsHolder: AlertsHolder;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private backendService: PaytronBackendService,
    private translate: TranslateService,
    private configService: ConfigService
  ) {
    this.currentConfiguration = this.configService.getConfiguration();
    this.addModalAlertsHolder = new AlertsHolder(translate);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
    this.bsConfig = this.currentConfiguration.datepickerConfig;
    this.loadZones();
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getPriceLists();
  }

  private getPriceLists() {
    this.backendService.getPriceLists().subscribe(
      (priceLists) => {
        this.priceLists = priceLists;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  private loadZones() {
    this.backendService.getZones().subscribe(
      (zones) => {
        this.zones = zones;
      },
      (err: HttpErrorResponse) => {}
    );
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  addPriceList() {
    this.currentPriceList = new PriceList();
    this.priceListForm.resetForm();
    this.startDate = new Date();
    this.endDate = null;
    this.showAddModal();
  }

  editPriceList(priceList: PriceList) {
    this.currentPriceList = priceList;
    this.startDate = new Date(this.currentPriceList.startDate);
    this.endDate = new Date(this.currentPriceList.endDate);
    this.showAddModal();
  }

  deletePriceList() {
    this.backendService
      .deletePriceList(this.currentPriceList)
      .subscribe(
        (data) => {
          this.getPriceLists();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeConfirmModal();
      });
  }

  submitPriceList(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.currentPriceList.startDate = this.startDate.toISOString();
    this.currentPriceList.endDate = this.endDate.toISOString();
    this.backendService
      .saveOrUpdatePriceList(this.currentPriceList)
      .subscribe(
        (priceList) => {
          this.getPriceLists();
          this.closeAddModal();
        },
        (err: HttpErrorResponse) => {
          let errorMessage;
          if (err.error.codeNumber === 'APP-026') {
            errorMessage = "Price list days overlap with another one in the same zone";
          } else {
            errorMessage = "There has been an error.";
          }
          this.addModalAlertsHolder.show(errorMessage, 'danger');
        }
      )
      .add(() => btnEvent.disabled = false);
  }

  compareZone(zone1: Zone, zone2: Zone): boolean {
    return zone1 && zone2 ? zone1.uuid === zone2.uuid : zone1 === zone2;
  }

  showAddModal() {
    this.priceListModal.show();
  }

  closeAddModal() {
    this.priceListModal.hide();
  }

  showConfirmModal(priceList) {
    this.currentPriceList = priceList;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  getTitle(msg: string) {
    return this.translate.instant(msg);
  }
}



// WEBPACK FOOTER //
// ./src/pages/price-list/price-list.ts